import { Injectable } from '@angular/core';
import { AppSettings } from '../../sharedcomponents/_common/constants/app.constants';
import { utilityService } from '../../sharedcomponents/commonservice/utility.service';
import { usercommonattribute } from '../../_services/userservice/user.common.service';
import { UserStateService } from './userstateservice';
import { UserProfileTMNIovation, enumEventype } from '../../models/user/user.tm.profile.model';
import { UserGioLocation } from '../../models/user/usergioLocation';
import { Ng2DeviceService } from 'ng2-device-detector';
declare var Crypto: any;
declare var CryptoService: any;
declare var ___MobileAgent___: any;

@Injectable()
export class AuthService {
  CryptoObj: any;
  cryptoService: any;
  result: any;
  publicKeyRSA: string;
  constructor(private utilserv: utilityService, private userCommon: usercommonattribute, private userStateService: UserStateService, private deviceService: Ng2DeviceService) {
    this.CryptoObj = Crypto;
    this.cryptoService = new CryptoService();
  }

  /* User Login*/
  // public logout(username: string, password: string) {
  //   return this.utilserv.soapPostwithoutAction(
  //     this.prepareEnvelopeLogin(
  //       this.cryptoService.RSAEncrypt(username, sessionStorage.publicKeyRSA),
  //       this.cryptoService.RSAEncrypt(password, sessionStorage.publicKeyRSA)
  //     ),
  //     AppSettings.loginService
  //   );
  // }
  public login(modelData: any, DeviceDetail: any, userGioLocation: UserGioLocation) {
    return this.utilserv.soapPostwithoutAction(this.prepareEnvelopeLogin(modelData, DeviceDetail, userGioLocation), AppSettings.loginService);
  }
  private prepareEnvelopeLogin(modelData: any, DeviceDetail: any, userGioLocation: UserGioLocation) {
    const envelope = `<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">
      <s:Header>
        <a:Action s:mustUnderstand="1">http://LoginSoapService/IMicroServiceLogin/Login</a:Action>
        <a:MessageID>urn:uuid:d6fe924c-4e95-451a-9338-11cbbdebf9de</a:MessageID>
        <a:ReplyTo>
          <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
        </a:ReplyTo>
      </s:Header>
      <s:Body>
        <LoginRequest xmlns="http://LoginSoapService/">
         <DeviceDetails xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroServices.Common" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
          <d4p1:Appversion>${AppSettings.Appversion}</d4p1:Appversion>
          <d4p1:DeviceBrowser>${DeviceDetail.browser}</d4p1:DeviceBrowser>
          <d4p1:DeviceID>${localStorage.sessionId}</d4p1:DeviceID>
          <d4p1:DeviceOS>${DeviceDetail.os}</d4p1:DeviceOS>
          <d4p1:DeviceOS_version>${DeviceDetail.os_version}</d4p1:DeviceOS_version>
          <d4p1:DeviceType>${DeviceDetail.device}</d4p1:DeviceType>
          <d4p1:DeviceUserAgent>${DeviceDetail.userAgent}</d4p1:DeviceUserAgent>
          <d4p1:EndIPAddress>${sessionStorage.EndUserIP}</d4p1:EndIPAddress>
          <d4p1:Latitude>${userGioLocation.latitude}</d4p1:Latitude>
          <d4p1:Longitude>${userGioLocation.longitude}</d4p1:Longitude>
          <d4p1:Platform>${AppSettings.Platform}</d4p1:Platform>
        </DeviceDetails>
         <DeviceToken>${modelData.DeviceToken}</DeviceToken>
          <KeyUID>${sessionStorage.KeyUID}</KeyUID>
          <LanguageCode>${sessionStorage.langCode}</LanguageCode>
          <OTP>${modelData.otpNumber}</OTP>
          <SessionId>${localStorage.sessionId}</SessionId>
          <UserInfo xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroServices.Common.MicroService" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
            <d4p1:Email>${this.cryptoService.RSAEncrypt(modelData.username, sessionStorage.publicKeyRSA)}</d4p1:Email>
            <d4p1:Password>${this.cryptoService.RSAEncrypt(modelData.password, sessionStorage.publicKeyRSA)}</d4p1:Password>
          </UserInfo>
        </LoginRequest>
      </s:Body>
    </s:Envelope>`;

    //console.log(envelope);
    return envelope;
  }
  /* User Login*/

  public sendDeviceDetails(modelData: usercommonattribute, DeviceDetail: any, userGioLocation: UserGioLocation) {
    return this.utilserv.soapPostwithoutAction(this.EnvelopeSendDeviceDetails(modelData, DeviceDetail, userGioLocation), AppSettings.loginService);
  }

  private EnvelopeSendDeviceDetails(modelData: usercommonattribute, DeviceDetail: any, userGioLocation: UserGioLocation) {
    const envelope = `<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">
    <s:Header>
      <a:Action s:mustUnderstand="1">http://LoginSoapService/IMicroServiceLogin/UserLogEvent</a:Action>
      <a:MessageID>urn:uuid:124e04de-fd3a-419d-a81a-28edbe7e3d00</a:MessageID>
      <a:ReplyTo>
       <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
      </a:ReplyTo>
    </s:Header>
    <s:Body>
      <UserLogRequest xmlns="http://LoginSoapService/">
        <Appversion>${AppSettings.Appversion}</Appversion>
        <CustomerId>${modelData.UserID}</CustomerId>
        <DeviceBrowser>${DeviceDetail.browser}</DeviceBrowser>
        <DeviceDetail xmlns:d4p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
          <d4p1:KeyValueOfstringstring>
            <d4p1:Key>DeviceOS</d4p1:Key>
            <d4p1:Value>${DeviceDetail.os}</d4p1:Value>
          </d4p1:KeyValueOfstringstring>
          <d4p1:KeyValueOfstringstring>
            <d4p1:Key>DeviceType</d4p1:Key>
            <d4p1:Value>${DeviceDetail.device}</d4p1:Value>
          </d4p1:KeyValueOfstringstring>
          <d4p1:KeyValueOfstringstring>
            <d4p1:Key>DeviceBrowser</d4p1:Key>
            <d4p1:Value>${DeviceDetail.browser}</d4p1:Value>
          </d4p1:KeyValueOfstringstring>
          <d4p1:KeyValueOfstringstring>
            <d4p1:Key>DeviceUserAgent</d4p1:Key>
            <d4p1:Value>${DeviceDetail.userAgent}</d4p1:Value>
          </d4p1:KeyValueOfstringstring>
          <d4p1:KeyValueOfstringstring>
           <d4p1:Key>DeviceOS_version</d4p1:Key>
            <d4p1:Value>${DeviceDetail.os_version}</d4p1:Value>
          </d4p1:KeyValueOfstringstring>
        </DeviceDetail>
        <DeviceID>${localStorage.sessionId}</DeviceID>
        <DeviceOS>${DeviceDetail.os}</DeviceOS>
        <DeviceOS_version>${DeviceDetail.os_version}</DeviceOS_version>
        <DeviceType>${DeviceDetail.device}</DeviceType>
        <DeviceUserAgent>${DeviceDetail.userAgent}</DeviceUserAgent>
        <EndIPAddress>${sessionStorage.EndUserIP}</EndIPAddress>
        <EndUserIP>${sessionStorage.EndUserIP}</EndUserIP>
        <EmailAddress>${modelData.email}</EmailAddress>
        <EndUserLatitude>${userGioLocation.latitude}</EndUserLatitude>
        <EndUserLongitude>${userGioLocation.longitude}</EndUserLongitude>
        <Event i:nil="true" xmlns:i="http://www.w3.org/2001/XMLSchema-instance" />
        <LanguageCode>${sessionStorage.langCode}</LanguageCode>
        <Phone>${modelData.mobile}</Phone>
        <Platform>${AppSettings.Platform}</Platform>
        <SessionObject xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroServices.Common.MicroService" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
        <d4p1:T1></d4p1:T1>
        <d4p1:T2>${sessionStorage.T2}</d4p1:T2>
        </SessionObject>
      </UserLogRequest>
    </s:Body>
  </s:Envelope>
  `;

    //console.log(envelope);
    return envelope;
  }

  public getWebSession() {
    return this.utilserv.soapPostwithoutAction(this.getWebSessionRequest(), AppSettings.FraudDetectionService);
  }

  private getWebSessionRequest () {
    return `
    <s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">
    <s:Header>
      <a:Action s:mustUnderstand="1">http://FraudDetectionSoapService/IMicroServiceFraudDetection/WebSession</a:Action>
      <a:MessageID>urn:uuid:4ad94341-97a6-490b-9376-682812f78dc7</a:MessageID>
      <a:ReplyTo>
        <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
      </a:ReplyTo>
    </s:Header>
    <s:Body />
  </s:Envelope>   
    `;
  }

  /* start FraudDetection*/
  public profileTMnIovation(userProfileTM: UserProfileTMNIovation) {
    return this.utilserv.soapPostwithoutAction(this.prepareEnvelopFraudDetection(userProfileTM), AppSettings.FraudDetectionService);
  }

private prepareEnvelopFraudDetection(userProfileTM: UserProfileTMNIovation) {
    if (localStorage.sessionId != '') {
        if (this.utilserv.getObjectText(userProfileTM.userProfile.IsBeingLinked) == 'false') {
            userProfileTM.userProfile.UserID = '';
        }

        const DeviceDetail = this.deviceService.getDeviceInfo();
        const envelope = `<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">
        <s:Header>
            <a:Action s:mustUnderstand="1">http://FraudDetectionSoapService/IMicroServiceFraudDetection/CheckFraudDetection</a:Action>
            <a:MessageID>urn:uuid:${this.generateUUID()}</a:MessageID>
            <a:ReplyTo>
                <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
            </a:ReplyTo>
            <a:To s:mustUnderstand="1">http://localhost:59647/MicroServiceFraudDetection.svc</a:To>
        </s:Header>
        <s:Body>
            <AppFraudDetectionRequest xmlns="http://FraudDetectionSoapService/">
                <BlackBoxInfo xmlns:b="http://schemas.datacontract.org/2004/07/ICE.MicroServices.Common.MicroService" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                    <b:DOB i:nil="true" />
                    <b:Email i:nil="true" />
                    <b:EventType i:nil="true" />
                    <b:FirstPatyBlackBox i:nil="true" />
                    <b:Mobile i:nil="true" />
                    <b:REMOTE_ADDR>${sessionStorage.EndUserIP}</b:REMOTE_ADDR>
                    <b:ThirdPatyBlackBox i:nil="true" />
                    <b:TransactionAmount>0</b:TransactionAmount>
                    <b:TransactionCurrency />
                    <b:TransactionId>0</b:TransactionId>
                    <b:UserName i:nil="true" />
                </BlackBoxInfo>
                <Detail xmlns:b="http://schemas.microsoft.com/2003/10/Serialization/Arrays" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                    <b:KeyValueOfstringstring>
                        <b:Key>DeviceOS</b:Key>
                        <b:Value>${DeviceDetail.os}</b:Value>
                    </b:KeyValueOfstringstring>
                    <b:KeyValueOfstringstring>
                        <b:Key>DeviceType</b:Key>
                        <b:Value>${DeviceDetail.device}</b:Value>
                    </b:KeyValueOfstringstring>
                    <b:KeyValueOfstringstring>
                        <b:Key>DeviceBrowser</b:Key>
                        <b:Value>${DeviceDetail.browser}</b:Value>
                    </b:KeyValueOfstringstring>
                    <b:KeyValueOfstringstring>
                        <b:Key>DeviceBrowser_version</b:Key>
                        <b:Value>${DeviceDetail.browser_version}</b:Value>
                    </b:KeyValueOfstringstring>
                    <b:KeyValueOfstringstring>
                        <b:Key>DeviceUserAgent</b:Key>
                        <b:Value>${DeviceDetail.userAgent}</b:Value>
                    </b:KeyValueOfstringstring>
                    <b:KeyValueOfstringstring>
                        <b:Key>DeviceOS_version</b:Key>
                        <b:Value>${DeviceDetail.os_version}</b:Value>
                    </b:KeyValueOfstringstring>
                    <b:KeyValueOfstringstring>
                        <b:Key>Platform</b:Key>
                        <b:Value>${AppSettings.Platform}</b:Value>
                    </b:KeyValueOfstringstring>
                </Detail>
                <DeviceInfo xmlns:b="http://schemas.datacontract.org/2004/07/ICE.MicroServices.Common" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                    <b:Appversion>${AppSettings.Appversion}</b:Appversion>
                    <b:DeviceBrowser>${DeviceDetail.browser}</b:DeviceBrowser>
                    <b:DeviceID>${localStorage.sessionId}</b:DeviceID>
                    <b:DeviceOS>${DeviceDetail.os}</b:DeviceOS>
                    <b:DeviceOS_version>${DeviceDetail.os_version}</b:DeviceOS_version>
                    <b:DeviceType>${DeviceDetail.device}</b:DeviceType>
                    <b:DeviceUserAgent>${DeviceDetail.userAgent}</b:DeviceUserAgent>
                    <b:EndIPAddress />
                    <b:Platform>2</b:Platform>
                </DeviceInfo>
                <EventType>${userProfileTM.eventType}</EventType>
                <Policy />
                <ThreatMatrixInfo xmlns:b="http://schemas.datacontract.org/2004/07/ICE.MicroServices.ExternalAPI.ThirdParty" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                    <b:AccountNumber />
                    <b:BeneficiaryDetails xmlns:c="http://schemas.datacontract.org/2004/07/ICE.MicroServices.Common">
                        <c:AdditionalLastName />
                        <c:CustomerEmail />
                        <c:DOB />
                        <c:FirstName />
                        <c:LastName />
                        <c:MiddleName />
                        <c:MobileNumber />
                        <c:PreferCountryCode />
                        <c:UserAddress>
                            <c:Address1 />
                            <c:CityCode />
                            <c:CountryCode />
                            <c:StateCode />
                            <c:ZipCode />
                        </c:UserAddress>
                        <c:UserID />
                    </b:BeneficiaryDetails>
                    <b:EventType i:nil="true" />
                    <b:InputIPAddress i:nil="true" />
                    <b:Policy i:nil="true" />
                    <b:SessionId>${userProfileTM.deviceProfile.SessionID}</b:SessionId>
                    <b:TransactionAmount i:nil="true" />
                    <b:TransactionCurrency i:nil="true" />
                    <b:TransactionId>0</b:TransactionId>
                    <b:UserDetails xmlns:c="http://schemas.datacontract.org/2004/07/ICE.MicroServices.Common">
                        <c:AdditionalLastName>${this.utilserv.getObjectText(userProfileTM.userProfile.additionalLastName)}</c:AdditionalLastName>
                        <c:CustomerEmail>${this.utilserv.getObjectText(userProfileTM.userProfile.email)}</c:CustomerEmail>
                        <c:DOB>${this.utilserv.getObjectText(userProfileTM.userProfile.dob)}</c:DOB>
                        <c:FirstName>${this.utilserv.getObjectText(userProfileTM.userProfile.firstName)}</c:FirstName>
                        <c:LastName>${this.utilserv.getObjectText(userProfileTM.userProfile.lastName)}</c:LastName>
                        <c:MiddleName></c:MiddleName>
                        <c:MobileNumber>${this.utilserv.getObjectText(userProfileTM.userProfile.mobile)}</c:MobileNumber>
                        <c:PreferCountryCode></c:PreferCountryCode>
                        <c:UserAddress>
                            <c:Address1>${this.utilserv.getObjectText(userProfileTM.userProfile.address)}</c:Address1>
                            <c:CityCode>${this.utilserv.getObjectText(userProfileTM.userProfile.city)}</c:CityCode>
                            <c:CountryCode>${this.utilserv.getObjectText(userProfileTM.userProfile.country)}</c:CountryCode>
                            <c:StateCode>${this.utilserv.getObjectText(userProfileTM.userProfile.state)}</c:StateCode>
                            <c:ZipCode>${this.utilserv.getObjectText(userProfileTM.userProfile.zipcode)}</c:ZipCode>
                        </c:UserAddress>
                        <c:UserID>${this.utilserv.getObjectText(userProfileTM.userProfile.UserID)}</c:UserID>
                    </b:UserDetails>
                </ThreatMatrixInfo>
            </AppFraudDetectionRequest>
        </s:Body>
        </s:Envelope>`;
        return envelope;
    }
}

// Método auxiliar para generar UUID
private generateUUID(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}
  public getUserDetail() {
    return this.utilserv.soapPostwithoutAction(this.prepareEnvelopeForGetUserDetail(), AppSettings.ICEUserMgmtService);
  }

  setUserDetails(resJSON) {
    this.userCommon.UserID = this.utilserv.getObjectText(resJSON.Envelope.Body.CustomerInfoResponse.UserID);
    this.userCommon.firstName = this.utilserv.getObjectText(resJSON.Envelope.Body.CustomerInfoResponse.FirstName);
    this.userCommon.middleName = this.utilserv.getObjectText(resJSON.Envelope.Body.CustomerInfoResponse.MiddleName);
    this.userCommon.lastName = this.utilserv.getObjectText(resJSON.Envelope.Body.CustomerInfoResponse.LastName);
    this.userCommon.additionalLastName = this.utilserv.getObjectText(resJSON.Envelope.Body.CustomerInfoResponse.AdditionalLastName);

    this.userCommon.dob = this.utilserv.getObjectText(resJSON.Envelope.Body.CustomerInfoResponse.DOB);
    this.userCommon.email = this.utilserv.getObjectText(resJSON.Envelope.Body.CustomerInfoResponse.CustomerEmail);

    this.userCommon.mobile = this.utilserv.getObjectText(resJSON.Envelope.Body.CustomerInfoResponse.MobileNumber);
    this.userCommon.countryPreference = this.utilserv.getObjectText(resJSON.Envelope.Body.CustomerInfoResponse.PreferCountryCode);
    this.userCommon.country = this.utilserv.getObjectText(resJSON.Envelope.Body.CustomerInfoResponse.Address.CountryCode);
    this.userCommon.state = this.utilserv.getObjectText(resJSON.Envelope.Body.CustomerInfoResponse.Address.StateCode);
    this.userCommon.stateName = this.utilserv.getObjectText(resJSON.Envelope.Body.CustomerInfoResponse.Address.StateName);
    this.userCommon.city = this.utilserv.getObjectText(resJSON.Envelope.Body.CustomerInfoResponse.Address.CityCode);
    this.userCommon.zipcode = this.utilserv.getObjectText(resJSON.Envelope.Body.CustomerInfoResponse.Address.ZipCode);

    this.userCommon.address = this.utilserv.getObjectText(resJSON.Envelope.Body.CustomerInfoResponse.Address.Address1);

    this.userCommon.occupation = this.utilserv.getObjectText(resJSON.Envelope.Body.CustomerInfoResponse.CustomerOccupation);
    this.userCommon.employess = this.utilserv.getObjectText(resJSON.Envelope.Body.CustomerInfoResponse.CustomerEmployer);
    this.userCommon.UserProfileImage = this.utilserv.getObjectText(resJSON.Envelope.Body.CustomerInfoResponse.UserProfileImage);
    this.userCommon.IsBeingLinked = this.utilserv.getObjectText(resJSON.Envelope.Body.CustomerInfoResponse.IsBeingLinked);
    this.userCommon.loyaltyCardNumber = this.utilserv.getObjectText(resJSON.Envelope.Body.CustomerInfoResponse.LoyaltyCardNumber);
    this.userCommon.LastOrderNumber = this.utilserv.getObjectText(resJSON.Envelope.Body.CustomerInfoResponse.LastOrderNumber);

    this.userCommon.maxTransferAmountLimit = this.utilserv.getObjectText(resJSON.Envelope.Body.CustomerInfoResponse.MaxTransferAmountLimit);

    // share credit
    this.userCommon.MarketingBalance =
      this.utilserv.getObjectText(resJSON.Envelope.Body.CustomerInfoResponse.MarketingBalance) == '' ? 0 : this.utilserv.getObjectText(resJSON.Envelope.Body.CustomerInfoResponse.MarketingBalance);
    // Not Required now
    this.userCommon.userimageurl = this.utilserv.getObjectText(resJSON.Envelope.Body.CustomerInfoResponse.UserProfileImage);
    this.userCommon.taxID = this.utilserv.getObjectText(resJSON.Envelope.Body.CustomerInfoResponse.TaxID);

    // sessionStorage.username = this.userCommon.firstName; //this.userCommon.lastName  ' ' +
    this.userStateService.setcurrentUserDetailData(this.userCommon);
    return this.userCommon;
  }

  private prepareEnvelopeForGetUserDetail() {
    const envelope = `<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">
                    <s:Header>
                      <a:Action s:mustUnderstand="1">http://tempuri.org/IICEUserMgmt/GetUserDetail</a:Action>
                      <a:MessageID>urn:uuid:60f29368-cea6-4182-a925-172499685570</a:MessageID>
                      <a:ReplyTo>
                      <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
                      </a:ReplyTo>
                    </s:Header>
                    <s:Body>
                      <RequestBase xmlns=\"http://tempuri.org/\">
                        <KeyUID>${sessionStorage.KeyUID}</KeyUID>
                        <LanguageCode>${sessionStorage.langCode}</LanguageCode>
                        <Session xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroService.Common.Contract"
                          xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                          <d4p1:T1>${sessionStorage.T1}</d4p1:T1>
                          <d4p1:T2>${sessionStorage.T2}</d4p1:T2>
                        </Session>
                      </RequestBase>
                    </s:Body>
                    </s:Envelope>`;
    //console.log(envelope);
    return envelope;
  }
  public setUserPrefCountry(userPrefCountry) {
    return this.utilserv.soapPostwithoutAction(this.prepareEnvelopeForSetUserPrefCountry(userPrefCountry), AppSettings.ICEUserMgmtService);
  }
  private prepareEnvelopeForSetUserPrefCountry(userPrefCountry) {
    const envelope = `<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">
                                                                             <s:Header>
                                                                               <a:Action s:mustUnderstand="1">http://tempuri.org/IICEUserMgmt/SetPreferCountry</a:Action>
                                                                               <a:MessageID>urn:uuid:fe637c1a-3a21-4c4b-8ad0-5e3cad5235b0</a:MessageID>
                                                                               <a:ReplyTo>
                                                                                 <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
                                                                               </a:ReplyTo>
                                                                             </s:Header>
                                                                             <s:Body>
                                                                               <CustomerInfoRequest xmlns="http://tempuri.org/">
                                                                                   <LanguageCode>${sessionStorage.langCode}</LanguageCode>
                                                                                <PreferCountryCode>${userPrefCountry}</PreferCountryCode>
                                                                                <Session xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroService.Common.Contract" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                                                                                   <d4p1:T1>${sessionStorage.T1}</d4p1:T1>
                                                                                   <d4p1:T2>${sessionStorage.T2}</d4p1:T2>
                                                                                 </Session>
                                                                               </CustomerInfoRequest>
                                                                             </s:Body>
                                                                           </s:Envelope>`;
    return envelope;
  }

  reprofile(userProfileTMNIovation: UserProfileTMNIovation, subProfile) {

    let _self = this;

    ___MobileAgent___.Profile().then(function (sessionId: string) {

      userProfileTMNIovation.deviceProfile.SessionID = sessionId;

      _self.utilserv.busy = _self.profileTMnIovation(userProfileTMNIovation).subscribe(data => {
              
              if (data.Envelope.Body.FraudDetectionResponse.StatusCode == 20001) {
                return false;
              }
              if (data.Envelope.Body.FraudDetectionResponse.StatusCode == 10000) {
                // sessionStorage.publicKeyRSA = resJSON.Envelope.Body.FraudDetectionResponse.RSAPublicKey;
                // sessionStorage.KeyUID = resJSON.Envelope.Body.FraudDetectionResponse.KeyUID;
                // this.userCommon.KeyUID = resJSON.Envelope.Body.FraudDetectionResponse.KeyUID;
                // Remove Script once Profiling is completed

                subProfile.next(true);
              } else {
                subProfile.next(false);
              }
            },
            error => {
              console.log('Observer got a next value: ' + error);
            }
          );
    });

    // const head = document.getElementsByTagName('head').item(0);
    // const script = document.createElement('script');
    // script.setAttribute('type', 'text/javascript');
    // // generate a new random session_id here to use in matching api call
    // script.setAttribute('src', AppSettings.tmService + userProfileTMNIovation.deviceProfile.SessionID + '&allow_reprofile=1');
    // head.appendChild(script);
    // this.utilserv.busy = this.profileTMnIovation(userProfileTMNIovation).subscribe(
    //   data => {
    //     const resJSON = data;
    //     head.removeChild(script);
    //     if (resJSON.Envelope.Body.FraudDetectionResponse.StatusCode == 20001) {
    //       return false;
    //     }
    //     if (resJSON.Envelope.Body.FraudDetectionResponse.StatusCode == 10000) {
    //       // sessionStorage.publicKeyRSA = resJSON.Envelope.Body.FraudDetectionResponse.RSAPublicKey;
    //       // sessionStorage.KeyUID = resJSON.Envelope.Body.FraudDetectionResponse.KeyUID;
    //       // this.userCommon.KeyUID = resJSON.Envelope.Body.FraudDetectionResponse.KeyUID;
    //       // Remove Script once Profiling is completed

    //       subProfile.next(true);
    //     } else {
    //       subProfile.next(false);
    //     }
    //   },
    //   error => {
    //     console.log('Observer got a next value: ' + error);
    //   }
    // );
    // return true;
  }
  generateRandomString(length) {
    let text = '';
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (let i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/userservice/auth.service.ts